class QuizAllergenWarning extends HTMLElement {
  constructor() {
    super();
    this.warningEl = null;
    this.step = null;
    this.mainQuiz = null;
    this.onCheckboxChange = null;
  }

  connectedCallback() {
    this.warningEl = this.querySelector('.quiz__allergen-warning');
    this.step = this.closest('quiz-step');
    this.mainQuiz = this.closest('main-quiz');
    this.groupName = this.dataset.groupName;
    this.onCheckboxChange = this.handleCheckboxChange.bind(this);
    this.step?.addEventListener('change', this.onCheckboxChange);
  }

  disconnectedCallback() {
    this.step?.removeEventListener('change', this.onCheckboxChange);
  }

  handleCheckboxChange(event) {
    if (event.target.type !== 'checkbox' || event.target.name !== this.groupName) return;

    const checkedValues = [
      ...this.step.querySelectorAll(`input[type="checkbox"][name="${this.groupName}"]:checked`),
    ].map((el) => el.value);

    const isBundleEmpty = this.checkBundleEmpty(checkedValues);
    this.warningEl.style.display = isBundleEmpty ? '' : 'none';

    if (this.step) {
      if (isBundleEmpty) {
        this.step.dataset.blockingValues = this.groupName || 'allergen';
      } else {
        delete this.step.dataset.blockingValues;
      }
      if (typeof this.step.updateNextButtonState === 'function') {
        this.step.updateNextButtonState();
      }
    }
  }

  checkBundleEmpty(allergenList) {
    const config = this.mainQuiz?.recommendationConfig;
    if (!config?.issues) return false;

    const storageKey = this.mainQuiz?.storageKey || 'quiz_data';
    const quizData = JSON.parse(localStorage.getItem(storageKey) || '{}');
    const issueList = (quizData['issues'] || '').split(',').map((v) => v.trim()).filter(Boolean);

    const JOINT_CHEW_FAMILY = 'jc';
    const JOINT_LIQUID_FAMILY = 'jl';

    const uniqueFamilies = new Set();
    let jointTriggered = false;

    issueList.forEach((issue) => {
      const def = config.issues[issue];
      if (!def) return;
      if (def.family === 'joint') { jointTriggered = true; return; }
      uniqueFamilies.add(def.family);
    });

    if (jointTriggered) {
      uniqueFamilies.add(JOINT_CHEW_FAMILY);
      uniqueFamilies.add(JOINT_LIQUID_FAMILY);
    }

    if (uniqueFamilies.size === 0) return false;

    let bundle = [...uniqueFamilies];

    const familiesToRemove = new Set();
    allergenList.forEach((allergen) => {
      const restriction = config.allergy_filter?.restrictions?.[allergen];
      if (!restriction || restriction.klaviyo_only) return;
      restriction.removes_families.forEach((f) => familiesToRemove.add(f));
    });

    bundle = bundle.filter((f) => !familiesToRemove.has(f));

    return bundle.length === 0;
  }
}

if (!customElements.get('quiz-allergen-warning')) {
  customElements.define('quiz-allergen-warning', QuizAllergenWarning);
}
